import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'cap-invalid-request',
  templateUrl: './invalidrequest.component.html',
  styleUrls: ['./invalidrequest.component.scss']
})
export class InvalidRequestComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
